import { KEMembersListFilters } from '../../../styledComponents/ProductMembersList/KEMembersList/KEMembersFilters/keMembersFilters.models';

export const kePageFilters = [
  KEMembersListFilters.Search,
  KEMembersListFilters.Plan,
  KEMembersListFilters.MemberType,
  KEMembersListFilters.RenewStatus,
];
